var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScholarshipPayment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.322,
    height: 14.422,
    viewBox: "0 0 15.322 14.422",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-hand-holding-usd",
    "data-name": "Icon awesome-hand-holding-usd",
    d: "M7.256,4.065l1.408.4a.237.237,0,0,1-.065.465H7.676a.725.725,0,0,1-.29-.062.349.349,0,0,0-.4.056L6.5,5.419a.338.338,0,0,0,.042.518,2.058,2.058,0,0,0,.9.324v.5a.452.452,0,0,0,.451.451h.451a.452.452,0,0,0,.451-.451v-.5A1.585,1.585,0,0,0,10.174,4.49,1.653,1.653,0,0,0,8.966,3.146l-1.408-.4a.237.237,0,0,1,.065-.465h.924a.725.725,0,0,1,.29.062.349.349,0,0,0,.4-.056l.493-.493a.338.338,0,0,0-.042-.518,2.058,2.058,0,0,0-.9-.324v-.5A.452.452,0,0,0,8.338,0H7.887a.452.452,0,0,0-.451.451v.5A1.585,1.585,0,0,0,6.048,2.721,1.653,1.653,0,0,0,7.256,4.065Zm7.783,5.177a.846.846,0,0,0-1.135,0l-2.456,2.082a1.638,1.638,0,0,1-1.065.394H7.236a.451.451,0,0,1,0-.9H9.318a.9.9,0,0,0,.045-1.8H5.107a3.012,3.012,0,0,0-1.969.741L1.9,10.816H.425A.44.44,0,0,0,0,11.267v2.7a.44.44,0,0,0,.425.451h9.49a1.649,1.649,0,0,0,1.065-.394L15,10.619a.936.936,0,0,0,.037-1.377Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScholarshipPayment);
export default __webpack_public_path__ + "static/media/scholarship-payment.0f0213ac9984ea558225aeb8a4bbb1e3.svg";
export { ForwardRef as ReactComponent };